<template>
  <div>
    <!-- <filed v-for="(item,key) in arr" :key="key" @titleTxt="title(value,key)"></filed> -->
    <Space>
      &nbsp;&nbsp;溯源标题：
      <Input v-model="title1" placeholder="标题" style="width: 200px" />
    </Space>
    <br /><br />
    <Space>
      &nbsp;&nbsp;图片内容：
      <Input v-model="imgObj.title" placeholder="图片字段标题" style="width: 200px" />
    </Space>
    <br />
    <br />
    <FiledUpload :imgArr="imgObj.imgarr" @addImg="addImgArr"></FiledUpload>
    <br />
    <Space> &nbsp;&nbsp;文本字段： </Space>
    <!-- 文本字段 -->
    <!-- 输入框 -->
    <div class="container" v-for="(item, key) in arr" :key="key">
      <div class="container" v-if="item.type == 'text'">
        <br />
        <Input v-model="arr[key].title" placeholder="溯源标题" style="width: 100px" />
        <span class="line">&nbsp;-&nbsp;</span>
        <Input v-model="arr[key].message" placeholder="溯源内容" style="width: 300px" />
        <div class="jian" @click="jian(key)">
          <img class="jian_img" src="@/assets/images/jian.png" alt="" srcset="" />
        </div>
        <br />
      </div>
    </div>

    &nbsp;
    <Button type="info" @click="add()">新增字段</Button>&nbsp;
    <br /><br />
    <Space>
      &nbsp;&nbsp;备注说明：
      <Input v-model="remark" type="textarea" :autosize="{ minRows: 2, maxRows: 5 }" placeholder="请输入说明..."></Input>
    </Space>
    <div class="btn">
      <Button @click="echo()" type="success" style="width: 100px; height: 40px">保&nbsp;存</Button>
    </div>
  </div>
</template>

<script>
import { updataFiledList } from "@/api/index";
import FiledUpload from "@/views/FiledUpload";
export default {
  props: ["datas"],
  data() {
    return {
      title1: "",
      ClientCode: "",
      imgObj: {
        title: "",
        type: "img",
        imgarr: [],
      },
      arr: [],
      remark: "",
    };
  },
  watch: {
    datas(add, old) {
      this.updata()
      this.title1 = add.title;
      this.ClientCode = add.clientCode;
      this.remark = add.remark;
      var obj = JSON.parse(add.datas);
      obj.filter((p, key) => {
        if (p.type == "img") {
          this.imgObj.imgarr = p.imgarr;
          this.imgObj.title = p.title;
          this.imgObj.type = p.type;
        }
      });
      this.arr = obj.filter((p, key) => {
        if (p.type == "text") {
          return p;
        }
      });
      // this.imgObj = obj[1];
    },
  },
  components: {
    FiledUpload,
  },
  methods: {
    updata() {
      this.title1 = "";
      this.ClientCode = "";
      this.imgObj = {
        title: "",
        type: "img",
        imgarr: [],
      };
      this.arr = [];
      this.remark = "";
    },
    // 添加图片
    addImgArr(value) {
      this.imgObj.imgarr.push(value);
    },
    add() {
      this.arr.push({ title: "", type: "text", message: "" });
    },
    echo() {
      // 阻止进行传址操作
      let arr1 = JSON.parse(JSON.stringify(this.arr));

      let type = "文本";
      if (this.imgObj.imgarr.length !== 0) {
        arr1.unshift(this.imgObj);
        type = "文本,图片";
      }
      let datas = arr1;
      updataFiledList({
        id: this.datas.id,
        clientcode: this.ClientCode,
        dataType: type,
        datas: JSON.stringify(datas),
        titless: this.title1,
        remark: this.remark,
      }).then((res) => {
        if (res) {
          const arr = {
            title: this.title1,
            arr: JSON.stringify(this.arr),
          };
          this.$emit("results", arr);
          this.$Notice.success({ title: "修改成功" });
        } else {
          this.$Notice.error({ title: "修改失败" });
        }
      });
    },
    title(event, key) {
      this.arr[key].title = event;
    },
    message(event, key) {
      this.arr[key].message = event;
    },
    jian(key) {
      this.arr[key] = {};
      this.arr.splice(key, 1);
    },
  },
};
</script>

<style scoped>
.container {
  width: 100%;
  display: flex;
  flex-direction: row;
  padding: 5px;
}

.line {
  line-height: 32px;
}

.jian {
  margin-left: 10px;
  height: 32px;
  width: 32px;
  cursor: pointer;
}

.jian_img {
  width: 100%;
}
</style>
